import { useCallback, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";

import ACFFieldGroupForm from "../../../components/ACF/ACFFieldGroupForm";
import Loader from "../../../components/Loader";
import TabHeader from "../components/TabHeader";

import fields from "../../../acf-json/group_626b3e0c54245.json";
import { getMyFacilitatorAccount } from "../services/facilitatorAccountQuery";
import { updateFacilitatorAccount } from "../services/updateFacilitatorQuery";
import { useAuth } from "../../../services/wp.auth.service";
import { useNotifications } from "../../../components/NotificationsContext";

const MyAccountFacilitatorProfile = () => {

	const { user } = useAuth();
	const { addNotification } = useNotifications();
	const queryClient = useQueryClient();
	const [loading, setLoading] = useState(false);
	const {
		data: facilitatorAccount,
		isLoading
	} = getMyFacilitatorAccount(useQuery, user.facilitatorId);

	const {
		mutateAsync: updateFacilitator
	} = updateFacilitatorAccount(useMutation);

	const onSubmit = useCallback(async (contactInformation) => {
		setLoading(true);
		try {
			await updateFacilitator({
				contactInformation,
				id: user.facilitatorId
			});
			await queryClient.refetchQueries(["my_facilitator_account"]);
			addNotification({
				message: "Facilitator profile updated.",
				type: "success"
			});
		} catch (message) {
			addNotification({
				message,
				type: "danger"
			});
		}
		setLoading(false);
	}, []);
	return (
		<>
			<TabHeader description="This is your facilitator profile." title="My Facilitator Profile" />

			{
				isLoading
					? <Loader height="100%" width="300px" />
					: (
						<ACFFieldGroupForm
							fields={fields}
							formValues={facilitatorAccount}
							loading={loading}
							omitFields={["email"]}
							onSubmit={onSubmit}
						/>
					)
			}
		</>
	);
};

export default MyAccountFacilitatorProfile;
